import {AppState, Auth0Provider, User} from '@auth0/auth0-react';
import React, {ReactNode} from 'react';
import {useNavigate} from 'react-router-dom';

interface Props {
  children?: ReactNode
}

export const Auth0ProviderWithNavigate = (props: Props) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState, user?: User) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
      <Auth0Provider
          domain="login.onkensu.com"
          clientId="lQCbipNvxtMxanWhL2gPbCn4UpKEiVC0"
          authorizationParams={{
            scope: 'openid email profile',
            redirect_uri: window.location.origin,
            prompt: "select_account", // allow them to pick a different google account 
          }}
          onRedirectCallback={onRedirectCallback}
      >
        {props.children}
      </Auth0Provider>
  );
};